import {request} from "../../../helper/APIUtils";
import Alert from "react-s-alert";
import {hasUserRight, showAxiosError} from "../../../helper/helper";
import {CopyToClipboard} from "react-copy-to-clipboard";
import {UncontrolledTooltip} from "reactstrap";
import TextOverFlowTooltip from "../../../components/TextOverFlowTooltip";
import moment from "moment";
import React from "react";
import {UserRightsEnum} from "../../../helper/enums";

export function getDocumentStatusColumns(type){
    const documentStatusTypes = ["invoice","despatch","archiveInvoice","mm","smm","edefter","edefter-bildirim","eExpenseNote"];

    if(documentStatusTypes.includes(type))
        return ["Kod","Durumu","Sayısı",""]
    else
        return ["SGK Tipi","Sayısı",""];
}

export function getDocumentDetailColumns(env, isImpersonateCagriMerkeziAndBayiSorumlusu){
    const distributorList = env.state.distributorList;
    const type = env.state.documentType;
    const isImpersonate = isImpersonateCagriMerkeziAndBayiSorumlusu;
    const selectedProcessState = env.state.selectedProcessState;
    const dateType = env.state.dateType;
    if (type === "edefter-bildirim") {
        return [
            {
                Header: "Yıl",
                accessor: "year",
                sortable: true,
            },
            {
                Header: "Ay",
                accessor: "month",
                sortable: true,
            },
            {
                Header: "VKN",
                accessor: '',
                sortable: false,
                Cell: row => (<div>{row.customer? row.customer.vknTckn:""}</div>),
            },
            {
                Header: "Durum",
                accessor: "status",
                sortable: true,
            },
            {
                Header: "Mesaj",
                accessor: "message",
                sortable: false,
            },
            {
                Header: "Detay",
                accessor: "",
                Cell: row => (
                    <div>
                        {(row.status === "Boş" || row.status === "Bekliyor" || row.status === "Hatalı") &&
                        <button type="button"
                                onClick={() => {
                                    let formData = new FormData;
                                    formData.append("recordId", row.recordId)
                                    request({
                                        url:`/secondaryCopyTransfer/delete`,
                                        method :'post',
                                        data: formData
                                    }).then(response => {
                                        Alert.success("Yeniden deneme başlatildi.", {
                                            position: 'top-right',
                                            effect: 'stackslide',
                                            timeout: 4000
                                        });
                                        env.fetchDetail(undefined, undefined, env.state.page, env.state.size);
                                    }).catch(error => showAxiosError(error));
                                }}
                                data-toggle="tooltip" data-placement="bottom" title="Yeniden Dene"
                                style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)'}}
                                rel="tooltip"
                                className="Btn btn-icon">
                            <i className="fas fa-refresh"/>
                        </button>}
                        {hasUserRight(UserRightsEnum.entegratorSettings.accessCustomerPortal, env.props.currentUser) &&
                        <button type="button" onClick={() => env.impersonateCustomerId(row.customer)} rel="tooltip"
                                disabled={isImpersonate}
                                className="Btn btn-icon" title="Kullanıcı Portalına Git"
                                style={{background: 'rgb(52, 216, 103)'}}>
                            <i className="fa fa-desktop"/>
                        </button>
                        }
                    </div>
                )
            }];
    } else if (type === "edefter") {
        return [
            {
                Header: "VKN",
                accessor: '',
                sortable: false,
                Cell: row => (<div>{row.customer? row.customer.vknTckn : '-'}</div>),
            },
            {
                Header: "Dönem",
                accessor: "period",
                sortable: true,
            },
            {
                Header: "Mesaj",
                accessor: "message",
                sortable: true,
            },
            {
                Header: "Defter Raporu",
                accessor: '',
                sortable: false,
                Cell: row => (<div>{row.trialBalanceSent ? "Gönderildi" : "Gönderilmedi"}</div>),
            },
            {
                Header: "İşlenme Durumu",
                accessor: '',
                sortable: false,
                Cell: row => (<div>{row.processing ? "Devam Ediyor" : "Beklemede"}</div>),
            },
            {
                Header: "Oluşturulma Tarihi",
                accessor: "created_at",
                sortable: false,
            },
            {
                Header: "Gönderilme Tarihi",
                accessor: "send_at",
                sortable: false,
            },
            {
                Header: "Bayi",
                accessor: '',
                sortable: false,
                Cell: row => (<div>{env.findDistributors(row.customer)}</div>
                )
            },
            {
                Header: "Detay",
                accessor: "",
                Cell: row => (
                    <div>
                        {(row.errorOccured || row.processing) &&
                        <button type="button"
                                onClick={() => {
                                    request({
                                        url:`/edefter-status/retry/${row.id}`,
                                        method :'post'
                                    }).then(response => {
                                        Alert.success("Yeniden deneme başlatildi.", {
                                            position: 'top-right',
                                            effect: 'stackslide',
                                            timeout: 4000
                                        });
                                        env.fetchDetail(undefined, undefined, env.state.page, env.state.size);
                                    }).catch(error => showAxiosError(error));
                                }}
                                data-toggle="tooltip" data-placement="bottom" title="Yeniden Dene"
                                style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)'}}
                                rel="tooltip"
                                className="Btn btn-icon">
                            <i className="fas fa-refresh"/>
                        </button>}
                        {hasUserRight(UserRightsEnum.entegratorSettings.accessCustomerPortal, env.props.currentUser) &&
                        <button type="button" onClick={() => env.impersonateCustomerId(row.customer)} rel="tooltip"
                                disabled={isImpersonate}
                                className="Btn btn-icon" title="Kullanıcı Portalına Git"
                                style={{background: 'rgb(52, 216, 103)'}}>
                            <i className="fa fa-desktop"/>
                        </button>
                        }
                    </div>
                )
            }];
    } else if (type === "sgkInvoice"){
        return [
            {
                Header: "Vkn/Tckn",
                accessor: "vknTckn",
                sortable: true,
            },
            {
                Header: "GLN",
                accessor: "username",
                sortable: true,
            },
            {
                Header: "Unvan",
                accessor: "formattedName",
                sortable: true,
            },
            {
                Header: "İsim",
                accessor: "givenName",
                sortable: true,
            },
            {
                Header: "Soyisim",
                accessor: "familyName",
                sortable: true,
            },
            {
                Header: "Sorumlu Cep Tel",
                accessor: "sorumluCepTel",
                sortable: true,
            },
            {
                Header: "Telefon",
                accessor: "phone",
                sortable: true,
            },
            {
                Header: "EPosta",
                accessor: "sorumluEposta",
                sortable: true,
            }
        ]
    } else if (type === "eExpenseNote"){
        return [
            {
                Header: (<input type="checkbox" checked={env.state.selectedAll}
                                onChange={(e) => env.toggleCheckboxChange(e, "all", "recordId")}/>),
                accessor: "recordId",
                selectType: "checkbox",
                sortable: false,
                Cell: (row, index) => (<input type="checkbox" checked={env.isSelected(row.recordId)}
                                              onChange={(e) => env.toggleCheckboxChange(e, row, "recordId", index)}/>)
            },
            {
                Header: "ETTN",
                accessor: "documentUuid"
            },
            {
                accessor: [
                    {Header: "VKN/TCKN", accessor: "destinationId"},
                    {Header: "Pusula No", accessor: "documentId"}
                ],
                Cell: row => (<div style={{margin: 0}}><TextOverFlowTooltip text={row.destinationId} maxLength={25}/>
                    <br/> {row.documentId}</div>)
            },
            {
                Header: "Alıcı Unvan",
                accessor: "destinationTitle"
            },
            {
                accessor: [
                    {Header: "Pusula Tarihi", accessor: "documentIssueDate"},
                    {Header: "Alınma Tarihi", accessor: "receivedDate"}
                ],
                Cell: row => (
                    <div
                        style={{margin: 0}}>{moment(row.documentIssueDate).isValid() ? moment(row.documentIssueDate).format("DD-MM-YYYY HH:mm:ss") : ''}
                        <br/> {moment(row.receivedDate).isValid() ? moment(row.receivedDate).format("DD-MM-YYYY HH:mm:ss") : ''}
                    </div>)
            },
            {
                Header: "Senaryo Türü",
                accessor: "documentProfile"
            },
            {
                Header: "Pusula Türü",
                accessor: "invoiceTypeCode"
            },
            {
                Header: "Doküman durumu",
                accessor: "documentProfile",
                sortable: false,
                Cell: row => (<div style={{margin: 0, padding: 0}}>
                    <div>
                        <p className={env.getExplanationColor()}
                           id={"stateCode" + row.recordId}
                           style={{margin: 0}}>{env.state.selectedStatus.explanation}</p>
                        {row.resultExplanation &&
                        <UncontrolledTooltip placement="right" target={"stateCode" + row.recordId} delay={0}>
                            {env.getResultExplanation(row)}
                        </UncontrolledTooltip>
                        }
                    </div>
                </div>)
            },
            {
                Header: "İşlemler",
                Cell: row => (
                    hasUserRight(UserRightsEnum.entegratorSettings.accessCustomerPortal, env.props.currentUser) &&
                    <button type="button" onClick={() => env.impersonateBySourceId(row)} rel="tooltip"
                            disabled={isImpersonate && hasUserRight(UserRightsEnum.entegratorSettings.accessCustomerPortal, env.props.currentUser)}
                            className="Btn btn-icon" title="Kullanıcı Portalına Git"
                            style={{background: 'rgb(52, 216, 103)'}}>
                        <i className="fa fa-desktop"/>
                    </button>
                )
            }
        ]
    } else if(type === "smm"){
        return [
            {
                Header: (<input type="checkbox" checked={env.state.selectedAll}
                                onChange={(e) => env.toggleCheckboxChange(e, "all", "recordId")}/>),
                accessor: "recordId",
                selectType: "checkbox",
                sortable: false,
                Cell: (row, index) => (<input type="checkbox" checked={env.isSelected(row.recordId)}
                                              onChange={(e) => env.toggleCheckboxChange(e, row, "recordId", index)}/>)
            },
            {
                accessor: [
                    {Header: "Fatura No", accessor: "documentId"},
                    {Header: "ETTN", accessor: "documentUuid"}
                ],
                Cell: row => (
                    <div>
                        {row.documentId}
                        <br/>
                        {row.documentUuid}
                        {
                            ["invoice", "despatch"].includes(env.state.documentType) &&
                            <div>
                                <CopyToClipboard text={row.envelopeUuid}
                                                 onCopy={() => env.copied(row.envelopeUuid, env.state.documentType === "invoice" ? "Fatura" : "İrsaliye")}>
                                    <button className="btn btn-icon btn-neutral "
                                            style={{
                                                padding: "0px",
                                                margin: "0px",
                                                backgroundColor: "inherit",
                                                color: "#78b1d7"
                                            }}>
                                        <i className="fa fa-envelope"></i>
                                    </button>
                                </CopyToClipboard>

                                <a href={env.downloadLink("envelopeXML", row.envelopeUuid)}
                                   id={"recorId" + row.recordId}>
                                    <button className="btn btn-icon btn-neutral "
                                            style={{
                                                padding: "0px",
                                                margin: "0px",
                                                backgroundColor: "inherit",
                                                color: "#29506a"
                                            }}>
                                        <i className="fa fa-download"></i>
                                    </button>
                                </a>
                                <UncontrolledTooltip placement="bottom" target={"recorId" + row.recordId} delay={0}>
                                    {"Zarf XML İndir"}
                                </UncontrolledTooltip>
                            </div>
                        }

                    </div>
                )
            },
            {
                accessor: [
                    {Header: "Gönderici Unvan", accessor: "sourceTitle"},
                    {Header: "VKN/TCKN", accessor: "sourceId"}
                ],
                Cell: row => (<div style={{margin: 0}}><TextOverFlowTooltip text={row.sourceTitle} maxLength={25}/>
                    <br/> {row.sourceId}</div>)
            },
            {
                accessor: [
                    {Header: "Alıcı Unvan", accessor: "destinationTitle"},
                    {Header: "VKN/TCKN", accessor: "destinationId"}
                ],
                Cell: row => (<div style={{margin: 0}}><TextOverFlowTooltip text={row.destinationTitle} maxLength={25}/>
                    <br/> {row.destinationId}</div>)
            },
            {
                accessor: [
                    {Header: "Fatura Tarihi", accessor: "documentIssueDate"},
                    {Header: "Alınma Tarihi", accessor: "receivedDate"}
                ],
                Cell: row => (
                    <div
                        style={{margin: 0}}>{moment(row.documentIssueDate).isValid() ? moment(row.documentIssueDate).format("DD-MM-YYYY HH:mm:ss") : ''}
                        <br/> {moment(row.receivedDate).isValid() ? moment(row.receivedDate).format("DD-MM-YYYY HH:mm:ss") : ''}
                    </div>)
            },
            {
                accessor: [
                    {Header: "Senaryo Türü", accessor: "documentProfile"},
                    {
                        Header: env.getDocumentTypeCodeAccessor().title,
                        accessor: env.getDocumentTypeCodeAccessor().accessor
                    }
                ],
                Cell: row => (
                    <div style={{margin: 0}}>
                        <div>{row.documentProfile} <br/>
                            {row[env.getDocumentTypeCodeAccessor().accessor]}
                        </div>
                    </div>)
            },
            {
                Header: "Doküman Durumu",
                accessor: "documentProfile",
                sortable: false,
                Cell: row => (<div style={{margin: 0, padding: 0}}>

                    <div>

                        <p className={env.getExplanationColor()}
                           id={"stateCode" + row.recordId}
                           style={{margin: 0}}>{env.state.selectedStatus.explanation}</p>

                        {row.resultExplanation &&
                        <UncontrolledTooltip placement="right" target={"stateCode" + row.recordId} delay={0}>
                            {env.getResultExplanation(row)}
                        </UncontrolledTooltip>
                        }
                    </div>
                </div>)
            },
            {
                Header: "İşlemler",
                Cell: row => (
                    <div>
                        {moment.duration(moment().diff(moment(row.processStartDate))).asDays() < 7 &&  selectedProcessState.state === 120 && selectedProcessState.result === 3 &&
                            <button type="button"
                                    onClick={() => env.changeProcessState(row)}
                                    rel="tooltip"
                                    className="Btn btn-icon" title="Tekrar İmzaya Gönder"
                                    style={{background: 'rgb(52,139,216)'}}>
                                <i className="fa fa-send"/>
                            </button>
                        }
                        {hasUserRight(UserRightsEnum.entegratorSettings.accessCustomerPortal, env.props.currentUser) &&
                        <button type="button"
                                onClick={() => env.impersonateBySourceId(row)}
                                rel="tooltip"
                                disabled={isImpersonate}
                                className="Btn btn-icon" title="Kullanıcı Portalına Git"
                                style={{background: 'rgb(52, 216, 103)'}}>
                            <i className="fa fa-desktop"/>
                        </button>
                        }
                    </div>

                    /* <div className="btn-group">
                         <div className="dropdown">
                             <button className="MenuBtn2 listt btn btn-default" type="button"
                                     data-toggle="dropdown">Seçİnİz
                             </button>
                             <div className="dropdown-menu" aria-labelledby={"dropdownMenuButton_" + row.recordId}>

                                 <a className="dropdown-item" onClick={() => env.impersonateBySourceId(row)}>
                                     <i className="fa fa-desktop"/> Kullanıcı Portalına Git
                                 </a>
                             </div>
                         </div>
                     </div>*/
                )
            }


        ];
    } else{
        return [
            {
                Header: (<input type="checkbox" checked={env.state.selectedAll}
                                onChange={(e) => env.toggleCheckboxChange(e, "all", "recordId")}/>),
                accessor: "recordId",
                selectType: "checkbox",
                sortable: false,
                Cell: (row, index) => (<input type="checkbox" checked={env.isSelected(row.recordId)}
                                              onChange={(e) => env.toggleCheckboxChange(e, row, "recordId", index)}/>)
            },
            {
                accessor: [
                    {Header: "Fatura No", accessor: "documentId"},
                    {Header: "ETTN", accessor: "documentUuid"}
                ],
                Cell: row => (
                    <div>
                        {row.documentId}
                        <br/>
                        {row.documentUuid}
                        {
                            ["invoice", "despatch"].includes(env.state.documentType) &&
                            <div>
                                <CopyToClipboard text={row.envelopeUuid}
                                                 onCopy={() => env.copied(row.envelopeUuid, env.state.documentType === "invoice" ? "Fatura" : "İrsaliye")}>
                                    <button className="btn btn-icon btn-neutral "
                                            style={{
                                                padding: "0px",
                                                margin: "0px",
                                                backgroundColor: "inherit",
                                                color: "#78b1d7"
                                            }}>
                                        <i className="fa fa-envelope"></i>
                                    </button>
                                </CopyToClipboard>

                                <a href={env.downloadLink("envelopeXML", row.envelopeUuid)}
                                   id={"recorId" + row.recordId}>
                                    <button className="btn btn-icon btn-neutral "
                                            style={{
                                                padding: "0px",
                                                margin: "0px",
                                                backgroundColor: "inherit",
                                                color: "#29506a"
                                            }}>
                                        <i className="fa fa-download"></i>
                                    </button>
                                </a>
                                <UncontrolledTooltip placement="bottom" target={"recorId" + row.recordId} delay={0}>
                                    {"Zarf XML İndir"}
                                </UncontrolledTooltip>
                            </div>
                        }

                    </div>
                )
            },
            {
                accessor: [
                    {Header: "Gönderici Unvan", accessor: "sourceTitle"},
                    {Header: "VKN/TCKN", accessor: "sourceId"}
                ],
                Cell: row => (<div style={{margin: 0}}><TextOverFlowTooltip text={row.sourceTitle} maxLength={25}/>
                    <br/> {row.sourceId}</div>)
            },
            {
                accessor: [
                    {Header: "Alıcı Unvan", accessor: "destinationTitle"},
                    {Header: "VKN/TCKN", accessor: "destinationId"}
                ],
                Cell: row => (<div style={{margin: 0}}><TextOverFlowTooltip text={row.destinationTitle} maxLength={25}/>
                    <br/> {row.destinationId}</div>)
            },
            {
                accessor: [
                    {Header: "Fatura Tarihi", accessor: "documentIssueDate"},
                    {Header: "Alınma Tarihi", accessor: "receivedDate"}
                ],
                Cell: row => (
                    <div
                        style={{margin: 0}}>{moment(row.documentIssueDate).isValid() ? moment(row.documentIssueDate).format("DD-MM-YYYY HH:mm:ss") : ''}
                        <br/> {moment(row.receivedDate).isValid() ? moment(row.receivedDate).format("DD-MM-YYYY HH:mm:ss") : ''}
                    </div>)
            },
            {
                accessor: [
                    {Header: "Senaryo Türü", accessor: "documentProfile"},
                    {
                        Header: env.getDocumentTypeCodeAccessor().title,
                        accessor: env.getDocumentTypeCodeAccessor().accessor
                    }
                ],
                Cell: row => (
                    <div style={{margin: 0}}>
                        <div>{row.documentProfile} <br/>
                            {row[env.getDocumentTypeCodeAccessor().accessor]}
                        </div>
                    </div>)
            },
            {
                Header: "Doküman Durumu",
                accessor: "documentProfile",
                sortable: false,
                Cell: row => (<div style={{margin: 0, padding: 0}}>

                    <div>

                        <p className={env.getExplanationColor()}
                           id={"stateCode" + row.recordId}
                           style={{margin: 0}}>{env.state.selectedStatus.explanation}</p>

                        {row.resultExplanation &&
                        <UncontrolledTooltip placement="right" target={"stateCode" + row.recordId} delay={0}>
                            {env.getResultExplanation(row)}
                        </UncontrolledTooltip>
                        }
                    </div>
                </div>)
            },
            {
                Header: "İşlemler",
                Cell: row => (
                    hasUserRight(UserRightsEnum.entegratorSettings.accessCustomerPortal, env.props.currentUser) &&
                    <button type="button" onClick={() => env.impersonateBySourceId(row)} rel="tooltip"
                            disabled={isImpersonate && hasUserRight(UserRightsEnum.entegratorSettings.accessCustomerPortal, env.props.currentUser)}
                            className="Btn btn-icon" title="Kullanıcı Portalına Git"
                            style={{background: 'rgb(52, 216, 103)'}}>
                        <i className="fa fa-desktop"/>
                    </button>
                    /* <div className="btn-group">
                         <div className="dropdown">
                             <button className="MenuBtn2 listt btn btn-default" type="button"
                                     data-toggle="dropdown">Seçİnİz
                             </button>
                             <div className="dropdown-menu" aria-labelledby={"dropdownMenuButton_" + row.recordId}>

                                 <a className="dropdown-item" onClick={() => env.impersonateBySourceId(row)}>
                                     <i className="fa fa-desktop"/> Kullanıcı Portalına Git
                                 </a>
                             </div>
                         </div>
                     </div>*/
                )
            }


        ];
    }

}